import React, { createContext, useCallback, useContext, useRef } from 'react';

/**
 * MermaidSvgRegistryContext
 *
 * Holds a per-message registry mapping mermaid source text → PNG base64 string.
 * Each AI message wraps its render tree with <MermaidSvgRegistryProvider> so
 * diagrams from different messages are isolated from each other.
 *
 * Usage:
 *   - MermaidDiagram calls registerDiagram(chart, pngBase64) after rendering
 *   - MessageFooter calls getDiagrams() when the user triggers an export
 */
const MermaidSvgRegistryContext = createContext(null);

export const MermaidSvgRegistryProvider = ({ children }) => {
  // Use a ref so registrations don't trigger re-renders
  const registry = useRef({});

  const registerDiagram = useCallback((mermaidSource, pngBase64) => {
    registry.current[mermaidSource] = pngBase64;
  }, []);

  const getDiagrams = useCallback(() => {
    return { ...registry.current };
  }, []);

  return (
    <MermaidSvgRegistryContext.Provider value={{ registerDiagram, getDiagrams }}>
      {children}
    </MermaidSvgRegistryContext.Provider>
  );
};

export const useMermaidSvgRegistry = () => useContext(MermaidSvgRegistryContext);
